import { DataGridPro } from "@mui/x-data-grid-pro";
import { columns } from "layouts/matchmakers/shidduchRequests/components/requestItem";
import { Introduction } from "models/introduction/Introduction";
import { useEffect } from "react";
import { useState } from "react";
import { getNamesAsync } from "utils/enduserUtils";
import { getMMWarnings } from "utils/matchmakerUtils";

export const MatchmakerWarnings = ({ mmId }: { mmId: string }) => {
    const [warnings, setWarnings] = useState<Introduction[]>([]);

    useEffect(() => {
        getMMWarnings(mmId).then((warnings) => {
            setWarnings(warnings || []);
            getNamesAsync(warnings.map((r) => [r.initiatorProfile?.userId, r.responderProfile?.userId]).flat().filter((id) => id) as string[])
        });
    }, [mmId]);

    return (
        <DataGridPro
            rows={warnings}
            columns={columns(false, () => { })}
            getRowId={(row) => row.introductionId}
        />
    );
};

